import { render, staticRenderFns } from "./ModalGcc.vue?vue&type=template&id=01d340c0&"
import script from "./ModalGcc.vue?vue&type=script&lang=js&"
export * from "./ModalGcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports